<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_sampleSetName') || '中文名称'"
            prop="sampleSetName"
          >
            <el-input
              v-model="formData.sampleSetName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_sampleSetNameEn') || '英文名称'"
            prop="sampleSetNameEn"
          >
            <el-input
              v-model="formData.sampleSetNameEn"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_displayCategory') || '样品分类'"
            prop="categoryCode"
          >
            <category-cascader
              :masterCategoryCode.sync="formData.masterCategoryCode"
              :detailCategoryCode.sync="formData.categoryCode"
              :params="categoryParams"
              clearable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_sampleSource') || '样品来源'"
            prop="sampleSource"
          >
            <dict-select
              v-model="formData.sampleSource"
              url="/master/common/dict/biz"
              :body="{ dictType: 'sampleSource' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_sampleSalesSeason') || '销售季节'"
          >
            <dict-select
              v-model="formData.sampleSalesSeason"
              url="/master/common/dict/biz"
              :body="{ dictType: 'salesSeason' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.salesPersonName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_designer') || '设计师'">
            <dict-select
              v-model="formData.designerCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.designerName"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_scm') || '成品工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scm"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_scmProductNo') || '工厂产品编号'"
          >
            <el-input
              v-model="formData.scmProductNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              show-word-limit
              maxlength="50"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_moq') || '起订量'">
            <el-input-number
              v-el-inputnumber-default0
              v-model="formData.moq"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              :step="1"
              :precision="0"
              :min="0"
              controls-position="right"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_moqUnit') || '起订量单位'">
            <dict-select
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              v-model="formData.moqUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'moqUnit' }"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_costMainType') || '成本类型'"
            prop="costMainType"
          >
            <dict-select
              v-model="formData.costMainType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'costMainType' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_costPrice') || '成本价格'"
            prop="costPrice"
          >
            <el-input-number
              v-el-inputnumber-default0
              v-model="formData.costPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width:100%"
              clearable
              :step="0.01"
              :precision="2"
              :min="0"
              controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_costCurrency') || '成本币种'"
            prop="costCurrency"
          >
            <dict-select
              v-model="formData.costCurrency"
              url="/sys/common/dict/system"
              :body="{ dictType: 'currency' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              v-model="formData.quotedMethod"
              url="/sys/common/dict/system"
              :body="{ dictType: 'quotedMethod' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedPrice') || '建议报价'"
            prop="quotedPrice"
          >
            <el-input-number
              v-el-inputnumber-default0
              v-model="formData.quotedPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width:100%"
              clearable
              :step="0.01"
              :precision="2"
              :min="0"
              controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedCurrency') || '报价币种'"
            prop="quotedCurrency"
          >
            <dict-select
              v-model="formData.quotedCurrency"
              url="/sys/common/dict/system"
              :body="{ dictType: 'currency' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_sampleSetSize') || '套件产品规格'"
          >
            <el-input v-model="formData.sampleSetSize" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_cust') || '客户'">
            <dict-select
              v-model="formData.custCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_brand') || '品牌'">
            <dict-select
              v-model="formData.brandCode"
              url="/master/common/dict/brandSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('table_label_salesType') || '售价类型'">
            <dict-select
              v-model="formData.salesType"
              url="/sys/common/dict/system"
              :body="salesTypeParams"
              :placeholder="$l('pe_select_salesType') || '请选择售价类型'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('table_label_salesPrice') || '零售价'">
            <el-input-number
              v-el-inputnumber-default0
              v-model="formData.salesPrice"
              :placeholder="$l('pe_input_salesPrice') || '请输入零售价'"
              style="width:100%"
              clearable
              :step="0.01"
              :precision="2"
              :min="0"
              :max="99999999999.99"
              controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_salesCurrency') || '零售价货币'"
          >
            <dict-select
              v-model="formData.salesCurrency"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('pe_select_salesCurrency') || '请选择零售价货币'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('table_label_packageSize') || '包装尺寸'">
            <el-input
              v-model="formData.packageSize"
              :placeholder="$l('pe_input_packageSize') || '请输入包装尺寸'"
              clearable
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_packageMethod') || '包装方式'">
            <dict-select
              v-model="formData.packageMethod"
              url="/master/common/dict/biz"
              :body="packageMethodParams"
              :placeholder="$l('pe_select_packageMethod') || '请选择包装方式'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
              multiple
              @loaded="(items) => (packageMethodItems = items)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_customerProductNo') || '客人产品编号'"
          >
            <el-input
              v-model="formData.customerProductNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              :maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_proofingCycleDesc') || '打样周期说明'"
          >
            <el-input
              v-model="formData.proofingCycleDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              :maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_productionCycleDesc') || '生产周期说明'"
          >
            <el-input
              v-model="formData.productionCycleDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              :maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shipmentCycleDesc') || '出货周期说明'"
          >
            <el-input
              v-model="formData.shipmentCycleDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              :maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_setTagMemo') || '吊牌标签备注'">
            <el-input
              v-model="formData.setTagMemo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              :maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_sampleSetMemo') || '备注说明'">
            <el-input
              v-model="formData.sampleSetMemo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              :maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <DynamicForm
          ref="dynamicForm"
          v-model="dynamicFormData"
          :items.sync="formData.metadata"
          :disabled="disabled"
          :gutter="10"
        />
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import DynamicForm from '@/components/dynamic-form'
export default {
  mixins: [EditLoading],
  components: { DynamicForm },
  props: {
    disabled: { type: Boolean, default: true },
    sampleSetCode: { type: String, default: '' },
    change: { type: Boolean, default: true },
  },
  data() {
    return {
      currencyUnitParams: { dictType: 'currencyUnit' },
      salesTypeParams: { dictType: 'sampleSalesType' },
      packageMethodParams: { dictType: 'packageMethod' },
      formData: {
        productLine: 'ABSHome',
        salesPersonCode: '',
        salesPersonName: '',
        costMainType: 'Factory',
        costCurrency: 'CNY',
        quotedMethod: 'FOB',
        quotedCurrency: 'USD',
        salesType: 'Offline',
        metadata: [],
      },
      rules: {
        sampleSetName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        sampleSetNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        sampleSource: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        costMainType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        costPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
                return
              }
              callback()
            },
          },
        ],
        costCurrency: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        quotedPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$l('INDEX.tips_input_cannot_be_zero')))
                return
              }
              callback()
            },
          },
        ],
        quotedCurrency: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
      dynamicFormData: {},
      packageMethodItems: [],
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    categoryParams() {
      return { parentCode: this.formData.productLine, isEcom: 'N' }
    },
    packageMethodMaps() {
      if (!this.packageMethodItems?.length) return {}

      return Object.fromEntries(
        this.packageMethodItems.map((item) => [item.value, item]),
      )
    },
    packageMethodName() {
      const packageMethod = this.formData?.packageMethod || []
      return packageMethod
        .map((item) => this.packageMethodMaps[item]?.label)
        .filter(Boolean)
        .join('、')
    },
  },
  watch: {
    'formData.masterCategoryCode'(newVal, oldVal) {
      if (this.formData.metadata?.length && !oldVal && newVal) return
      if (!newVal) return (this.formData.metadata = [])
      this.$api
        .masSampleInputTemplateSelectApi({ sampleCategoryCode: newVal })
        .then((res) => {
          this.formData.metadata = res.body?.data || []
        })
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.sampleSetCode) {
        this.getData()
        return
      }

      const { userCode, userName, userNameEn } = this.userInfo || {}
      this.formData.salesPersonCode = userCode || ''
      this.formData.salesPersonName = [userNameEn, userName]
        .filter(Boolean)
        .join('-')
    },
    async getData() {
      const res = await this.$api
        .sampleSetInfoDetailApi({ sampleSetCode: this.sampleSetCode })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data }
      this.$emit('loaded', data)
    },
    async reload() {
      const res = await this.$api
        .sampleSetInfoDetailApi({ sampleSetCode: this.sampleSetCode })
        .catch(() => null)
      const data = res?.body || {}
      const { sampleSetSize } = data
      this.formData = { ...this.formData, sampleSetSize }
    },
    async save() {
      const result = await validate.formValidate([
        this.$refs.form,
        this.$refs.dynamicForm,
      ])
      if (!result) return

      if (this.loadingOpen()) return

      const res = await this.saveApi(this.formData)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.$eventBus.$emit('setproofing-table-reload')
      if (this.sampleSetCode) {
        this.getData()
        return
      }
      const { sampleSetCode, sampleSetNo } = body
      this.$router.replace({
        name: 'sample-setproofing-detail',
        params: { sampleSetCode, pageType: 'edit' },
        query: { sampleSetNo },
      })
    },
    async saveApi(params) {
      const submitData = {
        ...params,
        packageMethodName: this.packageMethodName,
      }
      return this.change
        ? this.$api.sampleSetInfoChangeApi(submitData).catch(() => null)
        : this.$api.sampleSetInfoSaveApi(submitData).catch(() => null)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
